var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeingJournalEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.731 482.096-7.176-14.909h-47.388l-10.809 14.909v26.927c0 2.58 3.062 3.934 4.97 2.199l25.717-23.38c1.133-1.03 2.864-1.03 3.998 0l25.718 23.38c1.909 1.735 4.97.381 4.97-2.199z",
    fill: "#ecbe6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.358 395.889h65.373v86.207h-65.373z",
    fill: "#eab14d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.299 0h-8.59l-24.995 12.877-20.568-12.877h-253.512c-10.527 0-19.06 8.534-19.06 19.061v417.693c0 10.527 8.534 19.06 19.061 19.06h253.511l22.782-10.261 22.782 10.261h8.59c22.162 0 40.128-17.966 40.128-40.128v-375.558c-.002-22.162-17.967-40.128-40.129-40.128z",
    fill: "#e28086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.094 131.591h-166.405c-4.376 0-7.924-3.548-7.924-7.924v-52.497c0-4.376 3.548-7.924 7.924-7.924h166.405c4.376 0 7.924 3.548 7.924 7.924v52.497c.001 4.376-3.547 7.924-7.924 7.924z",
    fill: "#bed8fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.358 0h-22.724c-10.526 0-19.06 8.534-19.06 19.061v417.693c0 10.527 8.534 19.061 19.061 19.061h22.723z",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.299 0h-29.202c22.162 0 40.128 17.966 40.128 40.128v375.559c0 22.162-17.966 40.128-40.128 40.128h29.202c22.162 0 40.128-17.966 40.128-40.128v-375.559c-.001-22.162-17.966-40.128-40.128-40.128z",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.146 0h45.563v455.814h-45.563z",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.146 455.814 22.201-9.999v-433.779l-1.633.841-20.568-12.877h-23.362v455.814z",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.347 67.985c-1.227-2.789-4.01-4.739-7.253-4.739h-38.31v68.345h38.31c3.242 0 6.026-1.95 7.253-4.739z",
    fill: "#9dc6fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.146 0h45.563v455.814h-45.563z",
    fill: "#ffd064"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingJournalEmpty);
export default __webpack_public_path__ + "static/media/wellbeing-journal-empty.78fc0ecd0e9ba8b06318d6903227514e.svg";
export { ForwardRef as ReactComponent };